<template>
  <component :is="layout"></component>
</template>

<script setup>
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
const route = useRoute();
const layout = ref("empty-layout");

watch(() => route.meta?.layout, (newVal) => {
  layout.value = newVal || "empty-layout";
}, { immediate: true });
</script>
<style lang="less">
@success: #52c41a;
@info: #1890ff;
@warning: #f19240;
@warning-disabled: #f3d19e;
@error: #f5222d;
@gray: #818181;
@purple: #9c27b0;
@orange: #FF6A00;
@white: #fff;
@black: #000;
@cyan: #2db7f5;
@primary: #7ca4d2;
@teal: #2298a2;
@textposition: left, right, center;
@spacing: 5px;

.colors() {
  success: @success;
  info: @info;
  warning: @warning;
  warning-disabled: @warning-disabled;
  error: @error;
  gray: @gray;
  purple: @purple;
  orange: @orange;
  white: @white;
  black: @black;
  cyan: @cyan;
  primary: @primary;
  teal: @teal;
}

.textsizes() {
  h1: 2.5rem;
  h2: 2.25rem;
  h3: 2rem;
  h4: 1.75rem;
  h5: 1.5rem;
  h6: 1.25rem;
  h7: 1rem;
  h8: 0.95rem;
  h9: 0.9rem;
  h10: 0.85rem;
}

each(range(10), {
  .ma-@{value} {
    margin: (@value * @spacing) !important;
  }

  .mt-@{value} {
    margin-top: (@value * @spacing) !important;
  }

  .mr-@{value} {
    margin-right: (@value * @spacing) !important;
  }

  .mb-@{value} {
    margin-bottom: (@value * @spacing) !important;
  }

  .ml-@{value} {
    margin-left: (@value * @spacing) !important;
  }

  .pa-@{value} {
    padding: (@value * @spacing) !important;
  }

  .pt-@{value} {
    padding-top: (@value * @spacing) !important;
  }

  .pr-@{value} {
    padding-right: (@value * @spacing) !important;
  }

  .pb-@{value} {
    padding-bottom: (@value * @spacing) !important;
  }

  .pl-@{value} {
    padding-left: (@value * @spacing) !important;
  }

  .w-@{value} {
    width: (@value * @spacing) !important;
  }

  .h-@{value} {
    height: (@value * @spacing) !important;
  }
});

each(.colors(), .(@v, @k, @i) {
    .text-@{k} {
      color: @v !important;
    }

    .btn-@{k} {
      color: #fff !important;
      border-color: @v !important;
      background-color: @v !important;
    }

    .tag-@{k} {
      color: #fff !important;
      border-color: @v !important;
      background-color: @v !important;
    }

    .bg-@{k} {
      background-color: @v !important;
    }
  });

each(@textposition, {
  .text-@{value} {
    text-align: @value !important;
  }
});

each(.textsizes(), .(@v, @k, @i) {
    .text-@{k} {
      font-size: @v !important;
    }
  });

.in1line {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.in2line {
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.in3line {
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.in4line {
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}

.in5line {
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}

#nprogress .bar {
  background: red !important; //自定义颜色
}

.d-flex {
  display: flex !important;
}

.flex {
  flex: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-column {
  flex-direction: column !important;
}

.justify-center {
  justify-content: center !important;
}

.justify-start {
  justify-content: flex-start !important;
}

.justify-end {
  justify-content: flex-end !important;
}

.justify-space-between {
  justify-content: space-between !important;
}

.align-center {
  align-items: center !important;
}

.align-start {
  align-items: flex-start !important;
}

.align-end {
  align-items: flex-end !important;
}

.font-weight-bold {
  font-weight: bold !important;
}

.click {
  cursor: pointer !important;
}

.underline {
  text-decoration: underline !important;
}

.link {
  cursor: pointer !important;
  text-decoration: underline !important;
}

.disabled {
  cursor: not-allowed !important;
  opacity: 0.6;
}

.w_100 {
  width: 100%;
}

.h_100 {
  height: 100%;
}

p {
  margin: 0;
  padding: 0;
}
</style>
